import { render } from "./InputActionsWrapper.vue?vue&type=template&id=50ba57fa&scoped=true&ts=true"
import script from "./InputActionsWrapper.vue?vue&type=script&lang=ts"
export * from "./InputActionsWrapper.vue?vue&type=script&lang=ts"

import "./InputActionsWrapper.vue?vue&type=style&index=0&id=50ba57fa&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ba57fa"]])

export default __exports__